import { ImgHTMLAttributes } from 'react';

type AvatarSize = 32 | 36 | 48;

interface AvatarProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  size?: AvatarSize;
  src?: string;
  initials?: string;
  border?: boolean;
}

export function Avatar({ size = 36, src, initials, border = false, className = '', ...props }: AvatarProps) {
  const sizeClasses = {
    32: 'w-8 h-8 text-[12px]',
    36: 'w-9 h-9 text-[13px]',
    48: 'w-12 h-12 text-[16px]',
  };

  const borderClass = border ? 'border-2 border-white' : '';

  if (src) {
    return (
      <img
        src={src}
        alt={props.alt || 'Avatar'}
        className={`rounded-full object-cover ${sizeClasses[size]} ${borderClass} ${className}`}
        {...props}
      />
    );
  }

  return (
    <div
      className={`rounded-full bg-[#1B365D] text-white flex items-center justify-center font-semibold ${sizeClasses[size]} ${borderClass} ${className}`}
    >
      {initials}
    </div>
  );
}
